module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001350.205a00af.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001350.pdf
// module id = 341
// module chunks = 0